define( [
	"../var/document",
	"../var/support"
], function( document, support ) {

( function() {
	var div = document.createElement( "div" );

	// Support: IE<9
	support.deleteExpando = true;
	try {
		delete div.test;
	} catch ( e ) {
		support.deleteExpando = false;
	}

	// Null elements to avoid leaks in IE.
	div = null;
} )();

return support;

} );



// WEBPACK FOOTER //
// ./~/jquery/src/data/support.js